module.exports = __webpack_public_path__ + "img/brand-14.9dde27be.png";